<mat-dialog-content class="mat-dialog-content modal__window modal__window--error" *ngIf="data.error">

  <div class="box__heading box__heading--arrow">
    <h3>{{ title | translate }}</h3>
    <mat-icon matSuffix class="mat-icon material-icons modal__window--close" (click)="close()">close</mat-icon>
  </div>

  <div class="modal__window--content">

    <!-- List of errors with a general reason -->
    <div class="modal__window--subheader" *ngIf="generalReason"></div>
    @if (errors) {
    <mat-list>
      @for (item of errors; track $index) {
      <mat-list-item>
        @if (item.useCode) {
        <span>
          {{'errors.code.' + item.errorCode | translate}}
        </span>
        }@else {
        <span>
          {{item.errorMessage}}
        </span>
        }

      </mat-list-item>
      }
    </mat-list>
    }


    <!-- Application Error -->
    @if (!errors) {
    <div translate>errors.application.message</div>
    }

  </div>

  <div class="form__actions">
    <div class="form__buttons">
      <button class="btn btn__primary" type="submit" (click)="ok()" tabindex="0" translate>common.ok</button>
    </div>
  </div>

</mat-dialog-content>
